export default __webpack_public_path__ + "static/media/Strategy Builder.d740edfe.svg";